export default __webpack_public_path__ + "c439afb182fce11be2e577e4d7675bd7.svg";